import { Link } from "gatsby-plugin-react-intl";

import styled from "styled-components";

export const LogoWrapper = styled.a`
  display: inline-block;
  margin-right: 64px;
  transition: all 0.2s;
  width: 105px;

  :hover {
    opacity: 0.8;
  }

  @media (max-width: 849px) {
    width: 88px;
    height: 14px;
  }
`;

export const LogoOneWrapper = styled(Link)`
  display: inline-block;
  margin-right: 64px;
  transition: all 0.2s;
  width: 32px;

  :hover {
    opacity: 0.8;
  }
`;
